import { Button } from "src/components";

const UinDetails = ({ uinData, uinReqData, handleButtonClick }: { uinData: any; uinReqData: any; handleButtonClick?: any }) => {
  return (
    <section className="px-5 py-3">
      <table className="w-full border-collapse">
        <thead>
          <tr className="bg-[#f8f8f8] text-[#49484C]">
            <th className="p-4" />
            <th className="p-4">As per Medvol</th>
            <th className="p-4">As per Company</th>
          </tr>
        </thead>
        <tbody>
          <tr className="bg-white text-[#49484C]">
            <td className="p-4 bg-[#f8f8f8]">Name</td>
            <td className="p-4 font-semibold"> {uinReqData?.counter?.counter_name ?? "-"}</td>
            <td className="p-4 font-semibold">{uinData?.CompanyUINDetails?.Counter_Name ?? "-"}</td>
          </tr>
          <tr className="bg-white text-[#49484C]">
            <td className="p-4 bg-[#f8f8f8]">City</td>
            <td className="p-4 font-semibold">{uinReqData?.counter?.city_name ?? "-"}</td>
            <td className="p-4 font-semibold">{uinData?.CompanyUINDetails?.City ?? "-"}</td>
          </tr>
          <tr className="bg-white text-[#49484C]">
            <td className="p-4 bg-[#f8f8f8]">State</td>
            <td className="p-4 font-semibold">{uinReqData?.counter?.state_name ?? "-"}</td>
            <td className="p-4 font-semibold">{uinData?.CompanyUINDetails?.State_Name ?? "-"}</td>
          </tr>
          <tr className="bg-white text-[#49484C]">
            <td className="p-4 bg-[#f8f8f8]">UIN</td>
            <td className="p-4 font-semibold">{uinReqData?.uin_code ?? "-"}</td>
            <td className="p-4 font-semibold">{uinData?.CompanyUINDetails?.Counter_UIN ?? "-"}</td>
          </tr>
          <tr className="bg-white text-[#49484C]">
            <td className="p-4 bg-[#f8f8f8]">Alternate UIN</td>
            <td className="p-4 font-semibold">{uinReqData?.alternate_uin_code ?? "-"}</td>
            <td className="p-4 font-semibold">{uinData?.CompanyUINDetails?.Counter_AlternateUIN ?? "-"}</td>
          </tr>
          <tr className="bg-white text-[#49484C]">
            <td className="p-4 bg-[#f8f8f8]">UIN Speciality</td>
            <td className="p-4 font-semibold">{uinReqData?.uin_speciality ?? "-"}</td>
            <td className="p-4 font-semibold">{uinData?.CompanyUINDetails?.UIN_Speciality ?? "-"}</td>
          </tr>
          <tr className="bg-white text-[#49484C]">
            <td className="p-4 bg-[#f8f8f8]">Division Speciality</td>
            <td className="p-4 font-semibold">-</td>
            <td className="p-4 font-semibold">{uinData?.CompanyUINDetails?.Division_Speciality ?? "-"}</td>
          </tr>
        </tbody>
      </table>
      <footer className="flex justify-end gap-3 items-center ">
        <Button
          onClick={() => handleButtonClick("reject", uinReqData?.indph_uln_validation)}
          className="text-[#303030] border border-[#DODODO] bg-[#F1F1F1]"
        >
          Reject
        </Button>

        <Button onClick={() => handleButtonClick("approve", uinReqData?.indph_uln_validation)} className="text-[#E3E3E3] bg-[#8051FF]">
          Accept
        </Button>
      </footer>
    </section>
  );
};

export default UinDetails;
